import { combineReducers } from "redux";
import auth from "./auth";
import dealers from "./dealers";
import discounts from "./discounts";
import contracts from "./contracts";
import customers from "./customers";
import scooters from "./scooters";
import items from "./items";
import notes from "./notes";
import staffs from "./staffs";
import settings from "./settings";
import contacts from "./contacts";
import market from "./market";
import shoppingCart from "./shoppingCart";

const reducers = {
  auth,
  contacts,
  contracts,
  customers,
  dealers,
  discounts,
  items,
  market,
  notes,
  settings,
  scooters,
  staffs,
  shoppingCart
};

export default combineReducers(reducers);
